import { useInfiniteQuery } from '@tanstack/react-query';
import { getNews } from '../../services/client/news';

const LIMIT = 12;
export const useGetInifiniteNews = ({ enabled = false, startIndex = 1 }) => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading: isInitialLoading,
  } = useInfiniteQuery({
    queryKey: ['news'],
    queryFn: async ({ pageParam = startIndex }) => {
      const response = await getNews({
        skip: pageParam * LIMIT,
        limit: LIMIT,
      });
      return response.data.data;
    },
    initialPageParam: startIndex,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < LIMIT) return undefined;
      return allPages.length + startIndex;
    },
    enabled,
  });

  return {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isInitialLoading,
  };
};
